<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import DocumentGrid from '../Document/DocumentGrid'
import DocumentUpload from '../Document/DocumentUpload'

export default {
  name: 'CourseDocuments',
  props: ['courseId'],
  components: {
    DocumentGrid,
    DocumentUpload
  },
  data () {
    return {
      hideEntity: true
    }
  },
  computed: {
    ...mapState('courses', {
      courseId: state => state.courseForm.COURSE_ID
    }),
    ...mapState('documents', {
      documentUploadState: s => s.uploadModal.open
    }),
  },
  methods: {
  }
}
</script>

<template>
  <div class="fit">
    <DocumentGrid :entityItemId="courseId"  :deletable="true" />
    <document-upload v-if="documentUploadState" :hideEntity="hideEntity" :entityItemId="courseId"/>
  </div>
</template>

<style>
</style>
